module.exports = __webpack_public_path__ + "img/img_02.b6ec8bc3.jpg";